export const convertArrToObj = (arr) => {
  const odds = arr.reduce(function(acc, cur, i) {
    acc[cur.name] = cur.rate;
    return acc;
  }, {});
  return odds;
};
